import { LiveChatWidget as BaseLiveChatWidget } from "@livechat/widget-react";

import { licenseId } from "../constants/licenseId";

export const LiveChatWidget = () => <BaseLiveChatWidget license={licenseId} />;
